import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-phrases-quienes',
  templateUrl: './phrases-quienes.component.html',
  styleUrls: ['./phrases-quienes.component.css']
})
export class PhrasesQuienesComponent implements OnInit {

  @Input() phrasesQuienesSomos_items: any[] = []

  constructor() { }

  ngOnInit(): void {
  }

}
